import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  Button,
  IconButton,
  Modal,
} from "@mui/material";
import { Add, Delete, ExpandMore } from "@mui/icons-material";

const Points = ({ subData = [], onChange, error, touched }) => {
  const [openModal, setOpenModal] = useState(false);
  const [newPoints, setNewPoints] = useState([""]);

  const handleAddPoints = () => {
    const updatedData = [...subData, ...newPoints]; // Merge into single array
    onChange && onChange(updatedData);
    setNewPoints([""]);
    setOpenModal(false);
  };

  const handleDeletePoints = (indexToRemove) => {
    const updatedData = subData.filter((_, i) => i !== indexToRemove);
    onChange && onChange(updatedData);
  };

  const handlePointChange = (index, value) => {
    const updated = [...newPoints];
    updated[index] = value;
    setNewPoints(updated);
  };

  const handleAddMorePoint = () => {
    setNewPoints((prev) => [...prev, ""]);
  };

  const handleRemovePoint = (index) => {
    const updated = newPoints.filter((_, i) => i !== index);
    setNewPoints(updated);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>
        Sub Points*
      </Typography>

      <Box component="ul" sx={{ pl: 2 }}>
        {subData.map((point, index) => (
          <li
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 8,
            }}
          >
            <Typography>{point}</Typography>
            <IconButton onClick={() => handleDeletePoints(index)}>
              <Delete color="error" />
            </IconButton>
          </li>
        ))}
      </Box>

      <Button startIcon={<Add />} onClick={() => setOpenModal(true)}>
        Add Points
      </Button>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            Add Points
          </Typography>

          {newPoints.map((point, index) => (
            <Box key={index} display="flex" alignItems="center" gap={1} mt={1}>
              <TextField
                label={`Point ${index + 1}`}
                value={point}
                onChange={(e) => handlePointChange(index, e.target.value)}
                fullWidth
              />
              {newPoints.length > 1 && (
                <IconButton onClick={() => handleRemovePoint(index)}>
                  <Delete />
                </IconButton>
              )}
            </Box>
          ))}

          <Button
            startIcon={<Add />}
            onClick={handleAddMorePoint}
            sx={{ mt: 2 }}
          >
            Add More
          </Button>

          <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" onClick={() => setOpenModal(false)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddPoints}
              disabled={newPoints.some((p) => p.trim() === "")}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Modal>

      {error && touched && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default Points;
